import { ReactElement } from 'react';

import DentistSearch from '../../components/DentistSearch';
import { PageHelmet } from '../../components/PageHelmet';
import Banner from './Banner';
import IndicationForm from './IndicationForm';

export function AccreditedNetwork(): ReactElement {
  return (
    <div className="h-full min-h-[calc(100vh-549px)]">
      <PageHelmet title="Rede Credenciada | OdontoGroup" />

      <Banner
        page="rede-credenciada"
        title="Rede Credenciada"
        mainText="Precisa de ajuda para saber qual especialidade odontológica você precisa?"
      />

      <DentistSearch />

      <h3 className="mx-[10%] mb-7 mt-12 text-center text-[2.625rem] font-semibold text-primary-main min-[1059px]:mx-[20%] max-[1058px]:text-lg">
        Indique o seu dentista para fazer parte da rede credenciada da
        Odontogroup!
      </h3>

      <section className="bg-[url('/public/assets/images/hiring/ginger.png')] bg-contain bg-no-repeat p-3 min-[1059px]:min-h-[900px] min-[1059px]:p-10 max-[1059px]:mb-24">
        <div className="mt-24 rounded bg-white p-10 shadow-card min-[748px]:min-w-[676px] min-[1059px]:max-h-[40%] min-[1059px]:max-w-[30%] max-[748px]:p-5">
          <IndicationForm />
        </div>
      </section>
    </div>
  );
}
